import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { FullPageSpinner } from '@/components/ui/loading-spinner';
import Layout from '@/components/layout/Layout';
import ErrorBoundary from '@/components/ui/error-boundary';

interface LayoutRouteProps {
  children: React.ReactNode;
}

export const LayoutRoute: React.FC<LayoutRouteProps> = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return <FullPageSpinner message="Initializing application..." />;
  }

  return (
    <Layout>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </Layout>
  );
};
